<template>
  <form>
    <input-select
      title="Тип"
      option-title-key="title"
      option-value-key="value"
      v-bind:options="itemTypes"
      v-model="selectedType"
    />
    <form-price
      v-if="isSelectedPriceList"
      v-bind:inputErrors="inputErrors"
      v-on:close="onCloseForm"
      v-on:on-create-price-list="onSubmitFormPriceList"
      v-on:change-values="onChangeFieldValues"
    />
    <form-service-category-creation
      v-if="isSelectCategory"
      v-bind:price-list="servicePriceList"
      v-bind:initial-category-list="categoryList"
      v-bind:input-errors="inputErrors"
      v-bind:initial-price-id="initialServicePriceListId"
      v-on:form-submit="onSubmitFormCategory"
      v-on:close="onCloseForm"
      v-on:change-values="onChangeFieldValues"
    />
    <form-service-creation
      v-if="isSelectedService"
      v-bind:init-price-list="servicePriceList"
      v-bind:input-errors="inputErrors"
      v-bind:categories-without-price="categoryList"
      v-bind:service-tax-code-options="$options.serviceTaxCodeOptions"
      v-bind:initial-price-id="initialServicePriceListId"
      v-on:set-tax-code-for-all-services-in-category="onSetTaxCodeForAllServicesInCategory"
      v-on:close="onCloseForm"
      v-on:form-submit="onSubmitFormService"
      v-on:change-values="onChangeFieldValues"
    />
  </form>
</template>

<script>
import InputSelect from '@/components/InputSelect.vue';
import formServiceItemMixin from '@/mixins/formServiceItemMixin';
import FormServiceCategoryCreation from '@/components/FormServiceCategoryCreation.vue';
import FormPrice from '@/components/FormPrice.vue';
import FormServiceCreation from '@/components/FormServiceCreation.vue';

/**
 * @description Название события "Отправка формы категории".
 * @type {string}
 */
const ON_SUBMIT_CATEGORY = 'submit-category';

/**
 * @description Название события "Отправка формы прайс-листа".
 * @type {string}
 */
const ON_SUBMIT_PRICE_LIST = 'submit-price-list';

/**
 * @description Название события "Отправка формы услуги".
 * @type {string}
 */
const ON_SUBMIT_SERVICE = 'submit-service';

/**
 * @description Название события "Поля были изменены".
 * @type {string}
 */
const ON_CHANGE_FIELDS = 'change-fields';

/**
 * @description Название события "Установка кода услуги для всех услуг категории".
 * @type {string}
 */
const ON_SET_TAX_CODE_FOR_ALL_SERVICES_IN_CATEGORY = 'set-tax-code-for-all-services-in-category';

/**
 * @description Отправка события закрытия формы.
 * @type {string}
 */
const ON_CLOSE_FORM = 'close';

export default {
  name: 'FormServiceItem',
  components: {
    FormServiceCreation, FormPrice, FormServiceCategoryCreation, InputSelect,
  },
  computed: {
    /**
     * @description Начальное значение прайс-листа.
     * @returns {number}
     */
    initialServicePriceListId() {
      return this.servicePriceList.length >= 1 ? this.servicePriceList[0].id : undefined;
    },
  },
  methods: {
    /**
     * @description Обработать событие отправки категории.
     * @param request
     * @returns {void}
     */
    onSubmitFormCategory(request) {
      return this.$emit(ON_SUBMIT_CATEGORY, request);
    },
    /**
     * @description Обработать событие отправки прайс-листа.
     * @param request
     * @returns {void}
     */
    onSubmitFormPriceList(request) {
      return this.$emit(ON_SUBMIT_PRICE_LIST, request);
    },
    /**
     * @description Обработать событие отправки услуги.
     * @param request
     * @returns {void}
     */
    onSubmitFormService(request) {
      return this.$emit(ON_SUBMIT_SERVICE, request);
    },
    /**
     * @description Обработать событие изменения полей.
     * @param {string}  name      Название формы.
     * @param {boolean} isChanged Есть изменения.
     * @returns {void}
     */
    onChangeFieldValues(name, isChanged) {
      return this.$emit(ON_CHANGE_FIELDS, name, isChanged);
    },
    /**
     * @description Обработать установку кода услуги для всех услуг категории.
     * @param {number}  categoryId Идентификатор категории.
     * @param {?string} taxCode    Код услуги для налоговой.
     * @returns {void}
     */
    onSetTaxCodeForAllServicesInCategory(categoryId, taxCode) {
      this.$emit(ON_SET_TAX_CODE_FOR_ALL_SERVICES_IN_CATEGORY, categoryId, taxCode);
    },
    /**
     * @description Обработать событие закрытия формы.
     * @returns {void}
     */
    onCloseForm() {
      return this.$emit(ON_CLOSE_FORM);
    },
  },
  props: {
    /**
     * @description Прайс-листы
     * @type Array<ServicePriceList>
     */
    servicePriceList: {
      type: Array,
      required: true,
    },
    /**
     * @description Список категорий.
     * @type {Array}
     */
    categoryList: {
      type: Array,
      required: true,
    },
    /**
     * @description Список нарушений ограничений.
     * @type {Object}
     */
    inputErrors: {
      type: Object,
      required: true,
    },
  },
  mixins: [
    formServiceItemMixin,
  ],
  serviceTaxCodeOptions: [
    { title: '-', value: null },
    { title: '1', value: '1' },
    { title: '2', value: '2' },
  ],
};
</script>

<style scoped lang="scss">

</style>
